import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchStockAllPart() {
    try {
        let res = await client.get("/dashboard/stock-all-parts");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchStockParts() {
    try {
        let res = await client.get("/dashboard/stock-parts");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchUsageHistory(filter) {
    try {
        let res = await client.get(`/dashboard/usage-history?filter_time=${filter}`);

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchStockAllPart,
    fetchStockParts,
    fetchUsageHistory,
};